// 导出接口请求方法
import request from './request';
import apis from '@/config/apis';
// 情绪数据
export const getHomeEmotion = (params: any) => request.get(apis.homeEmotion, { params });
// 个股上涨空间排行
export const getHomeRaiseSpace = (params: any) => request.get(apis.homeRaiseSpace, { params });
// 个股上涨空间
export const getHomeSingleRaiseSpace = (params: any) => request.get(apis.homeSingleRaiseSpace, { params });
// 个股周期内股价
export const getHomeSingleStockPrice = (params: any) => request.get(apis.homeSingleStockPrice, { params });
// 个股周期内均价
export const getHomeSingleAvgPrice = (params: any) => request.get(apis.homeSingleAvgPrice, { params });
export const getHomeSingleRank = (params: any) => request.get(apis.oldInterface, { params });
export const getHomeGradeUpRank = (params: any) => request.get(apis.homeGradeUpRank, { params });
export const getHomeBuyRank = (params: any) => request.get(apis.homeBuyRank, { params });
export const getHomeAnalystRank = (params: any) => request.get(apis.homeAnalystRank, { params });
export const getOldInterface = (params: any) => request.get(apis.oldInterface, { params });
export const getOrgRank = (params: any) => request.get(apis.orgRank, { params });
export const getReadNum = (params: any) => request.jsonp(apis.readNum, params);
export const getFollow = (data: any) => request.post(apis.allFollow, data);
export const getHomeGoldStock = (params: any) => request.get(apis.homeGoldStock, { params });
export const getHomeDailyReport = (params: any) => request.get(apis.homeDailyReport, { params });
export const getHomeFirstCover = (params: any) => request.get(apis.homeFirstCover, { params });
export const getHomeStockPrice = (params: any) => request.get(apis.homeStockPrice, { params });
export const getHomeOneYearReport = (params: any) => request.get(apis.homeOneYearReport, { params });
export const getHomeScreenInfo = (params: any) => request.get(apis.homeScreenInfo, { params });
export const getFollowAuthor = (params: any) => request.get(apis.followAuthor, { params });
export const getFollowOrg = (params: any) => request.get(apis.followOrg, { params });
export const getFollowIndustry = (params: any) => request.get(apis.followIndustry, { params });
export const updateRead = (data: any) => request.post(apis.updateRead, data);
export const getFollowReport = (params: any) => request.get(apis.followReport, { params });
export const getReport = (params: any) => request.get(apis.getReport, { params });
export const getHomeTargetChart = (params: any) => request.get(apis.homeTargetChart, { params });
export const getHomeReportList = (params: any) => request.get(apis.homeReportList, { params });
export const getRankIndustryList = (params: any) => request.get(apis.rankIndustryList, { params });
export const getIframeChangeList = (params: any) => request.get(apis.iframeChangeList, { params });
export const getIframeForecastsList = (params: any) => request.get(apis.iframeForecastsList, { params });
export const getHomePotentialHistory = (params: any) => request.get(apis.homePotentialHistory, { params });
export const getIframeOrgRating = (params: any) => request.get(apis.iframeOrgRating, { params });
export const getRankNewWealth = (params: any) => request.get(apis.rankNewWealth, { params });
export const getRankNewWealthDetail = (params: any) => request.get(apis.rankNewWealthDetail, { params });
export const getRankSingle = (params: any) => request.get(apis.rankSingle, { params });
export const getRankAuthor = (params: any) => request.get(apis.rankAuthor, { params });
export const getNewWealthYear = (params: any) => request.get(apis.newWealthYear, { params });
export const getNewWealthBanner = (params: any) => request.get(apis.newWealthBanner, { params });
export const postNewWealthSaw = (params: any) => request.post(apis.newWealthSaw, params);
export const getUpdateRead = (data: any) => request.post(apis.updateIsRead, data);
export const create = (data: any) => request.post(apis.create, data);
export const getOperateConfig = (params: any) =>
  request.get(apis.operateConfig, {
    params,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  });
export const getHomeCourseOperate = () => request.get(apis.homeCourseOperate, {});
export const getKlineCourseOperate = (params: any) => request.get(apis.klineCourseOperate, { params });
// 人民币柜台映射关系
export const getCodeMap = (params: any) => request.get(apis.codeMap, { params });
// 查询K线分时 展示数据 情绪、变动提醒、运营位
export const getKlineCombined = (params: any) => request.get(apis.klineCombined, { params });
// 获取ai解读内容
export const getAiContent = (params: any) =>
  request.post(apis.aicontent, params, {
    withCredentials: true,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  });
